import * as React from 'react';
import { useSelector } from 'react-redux';
import { Header2, Header3, InlineText1, InlineText2 } from '@cian/ui-kit';
import classNames from 'classnames';

import { PROMOTION_SECTION_ID } from '../../../../constants/nodeIds';
import { useDeviceCondition } from '../../../../hooks';
import {
  selectIsWithoutMinimalBet,
  selectIsWithoutServices,
  selectIsPromotionPackageSelected,
} from '../../../../selectors/publishTerms';
import { AnimationLayout, AnimationElement } from '../../../common/Animation';

import { ServicesLayoutToggleContainer } from './components/ServicesLayoutToggle';
import { WithoutServicesScreenContainer } from './components/WithoutServicesScreen';
import { layoutAnimationConfig } from './constants';
import * as styles from './PromotionWrapper.css';

interface IPromotionWrapperProps {
  children: React.ReactNode;
  subheader: string | null;
}

export const PromotionWrapper = ({ subheader, children }: IPromotionWrapperProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);
  const Header = useDeviceCondition(Header2, Header3);
  const Subheader = useDeviceCondition(InlineText2, InlineText1);
  const isWithoutMinimalBet = useSelector(selectIsWithoutMinimalBet);
  const isWithoutServices = useSelector(selectIsWithoutServices);
  const isPromotionPackageSelected = useSelector(selectIsPromotionPackageSelected);

  const isWithoutServicesScreen = isWithoutServices;

  return (
    <div className={classNames(rootStyle, styles['wrapper'])}>
      <AnimationElement layout id={PROMOTION_SECTION_ID}>
        <div className={styles['header']}>
          <div>
            <AnimationElement layout="position">
              <Header>Продвижение в поиске</Header>
            </AnimationElement>

            {subheader && (
              <AnimationElement layout="position" className={styles['subheader']} {...layoutAnimationConfig}>
                <Subheader>{subheader}</Subheader>
              </AnimationElement>
            )}
          </div>

          <AnimationLayout>
            {isWithoutMinimalBet && !isPromotionPackageSelected && (
              <AnimationElement layout="position">
                <ServicesLayoutToggleContainer />
              </AnimationElement>
            )}
          </AnimationLayout>
        </div>

        <AnimationElement layout="position">
          {isWithoutServicesScreen ? <WithoutServicesScreenContainer /> : children}
        </AnimationElement>
      </AnimationElement>
    </div>
  );
};
